// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_UNd","cls2":"BulkFollowSuggestion-cls2_Ic4 BulkFollowSuggestion-cls1_UNd"};